<template>
  <ValidationObserver ref="observer">
    <div class="animated fadeIn">
      <b-row v-if="loading">
        <b-col cols="12" sm="12" md="6" class="text-center">
          <atom-spinner
            :animation-duration="1000"
            :size="60"
            color="#ff1d5e"
            class="my-4"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="isCreating"
        class="justify-content-center align-items-center"
      >
        <div class="loader">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
          <div class="bar4"></div>
          <div class="bar5"></div>
          <div class="bar6"></div>
          <div class="bar7"></div>
          <div class="bar8"></div>
          <div class="bar9"></div>
          <div class="bar10"></div>
          <div class="bar11"></div>
          <div class="bar12"></div>
        </div>
      </b-row>
      <div v-else>
        <component-header
          title="Add Unit"
          :isLoading="loading"
          :hasReload="false"
          :hasSearch="false"
          :hasback="false"
          :hasCreate="false"
        />
        <b-card class="cardBg">
          <b-row class="mt-1">
            <b-col cols="12" md="3" class="mb-3">
              <eb-select
                type="select"
                label="name"
                :options="property"
                v-model="prop"
                placeholder="Select Property"
                class="currencyNameDropdown"
                @input="unitList"
              ></eb-select>
            </b-col>
            <b-col cols="12" md="3" class="mb-3">
              <eb-select
                type="select"
                label="label"
                placeholder="Select Unit Type"
                v-model="unitType"
                :options="unitOption"
                class="currencyNameDropdown"
              ></eb-select>
            </b-col>
            <b-col cols="12" md="2" class="mb-3">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="No of Units"
              >
                <c-input
                  inputType="text"
                  labelText="No of Units"
                  v-model="unit"
                />
                <span class="validate-error custm-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col>
            <b-col cols="12" md="2" class="mb-3">
              <p v-if="fileName" class="mt-2 font-weight-bold text-primary">
                {{ fileName }}
              </p>
              <div v-else class="upload_file-Custome d-flex align-items-center">
  <div class="file-upload-sec mr-2">
    <i class="fas fa-paperclip"></i>
  </div>

  <b-form-file
    class="flex-grow-1"
    placeholder="Upload file"
    drop-placeholder="Drop file here..."
    @change="readLogo"
    :state="Boolean(unitLogo)"
  ></b-form-file>

  <p class="mb-0 ml-2 file-hint">
    file (jpeg, pdf, etc.)
  </p>
</div>

            </b-col>
            <b-col cols="12" md="2" class="mb-3">
              <b-button class="w-100 btn-height-40" @click="create"
                >Add</b-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="4"
              lg="3"
              v-for="(unit, index) in units"
              :key="index"
              class="mb-3"
            >
              <div
                @click="
                  $router.push({
                    name: 'Unit list',
                    params: {
                      id: unit.provider,
                      bed: unit.Bedrooms,
                      bath: unit.Bathrooms,
                    },
                  })
                "
              >
                <cardView
                  :bedInfo="unit.Bedrooms"
                  :bathInfo="unit.Bathrooms"
                  :unitCount="unit.totalUnit"
                  :imageSrc="require('@/assets/images/building.jpg')"
                />
              </div>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
  </ValidationObserver>
</template>
<script>
import cardView from "@/components/cardView/index.vue";
import { AtomSpinner } from "epic-spinners";
import ebSelect from "@/components/FormElements/Select.vue";
import cInput from "@/components/FormElements/CustomInput";
import ComponentHeader from "@/components/componentNewHeader";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate";
export default {
  components: {
    AtomSpinner,
    ebSelect,
    cInput,
    cardView,
    ComponentHeader,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
      isCreating: false,
      property: [],
      prop: "",
      unit: "",
      unitType: "",
      unitOption: [
        { label: "1 Bed 1 Bath" },
        { label: "2 Bed 2 Bath" },
        { label: "3 Bed 2.5 Bath" },
        { label: "studio" },
      ],
      businessNo: "",
      units: null,
      unitLogo: null,
      fileName: "",
      fileSize: "",
    };
  },
  methods: {
    readLogo(e) {
      const file = e.target.files[0];
      if (file) {
        this.fileName = file.name;
        this.fileSize = file.size;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.uploadImage(reader.result);
        };
        reader.onerror = (err) => {
          console.error("reader: ", err);
        };
      }
    },
    async uploadImage(image) {
      this.isCreating = true;
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant",
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          this.isCreating = false;
          if (res) {
            this.clearCustomToast();
            this.unitLogo = res.data.fileUrl;
          }
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    showCustomToast() {
      this.$toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      this.$toasted.clear();
    },
    async propertyList() {
      const data = await this.$store.dispatch(
        "unit/fetchPropertyList",
        "66f1000a05fe0c77e56a7624"
      );
      this.property = data.map((item) => {
        this.$store
          .dispatch("unit/fetchPropertyDetails", item._id)
          .then((res) => {
            this.businessNo = res?.businessNo;
          });
        if (item.office && item.office.officeName) {
          return {
            id: item._id,
            name: item.office.officeName,
          };
        }
        return null;
      });
    },
    async create() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.isCreating = true;
      try {
        const payload = {
          Unit: this.unit,
          Name: this.unitType.label,
          description_summary: this.unitType.label,
          provider: this.prop.id,
          catalogId: "66ffedc35c884bd41208a685",
          images: {
            icon: "https://calonex-dev.s3.amazonaws.com/images/seller/items/1727966854627",
            smallImage:
              "https://calonex-dev.s3.amazonaws.com/images/seller/items/1727966854627",
            bigImage:
              "https://calonex-dev.s3.amazonaws.com/images/seller/items/1727966854627",
            alternateImages: [
              {
                type: "unit",
                fileUrl: this.unitLogo,
                url: this.unitLogo,
                fileName: this.fileName,
                fileSize: this.fileSize,
              },
              {
                type: "floor",
                fileUrl: this.unitLogo,
                url: this.unitLogo,
                fileName: this.fileName,
                fileSize: this.fileSize,
              },
            ],
          },
          productType: "Normal",
          propertyBusinessNo: this.businessNo,
          Type: "UNIT",
          Price: 0,
          Description: this.unitType.label,
          Bathrooms: 0,
          Bedrooms: 0,
          Amenities: [],
          Occupancy: "VACANT",
          propertyStatus: "ACTIVE",
          City: "Ghatal",
          Country: "India",
          State: "West Bengal",
          Lng: 0,
          Lat: 0,
          Address: {
            Lng: 0,
            Lat: 0,
            City: "Ghatal",
            State: "West Bengal",
            Country: "India",
            Address: "Ghatal, West Bengal, 55997, undefined",
            location: [0, 0],
          },
          Area: "Ghatal, West Bengal, 55997, undefined",
          propertyImages: [
            {
              fileUrl:
                "https://calonex-dev.s3.amazonaws.com/images/seller/items/1727966759247",
              url: "https://calonex-dev.s3.amazonaws.com/images/seller/items/1727966759247",
              fileName: "pest.png",
              fileSize: "0.04",
            },
          ],
          propertyAmenities: [
            {
              description_summary: "Swimming pool",
              provider: this.prop.id,
              catalogId: "66ffedc35c884bd41208a685",
              productType: "Normal",
              Type: "PROPERTY_AMENITY",
              isDeleted: false,
              b2bType: "0",
              PaymentType: "Free",
              Price: 0,
              tenant: "66f1000a05fe0c77e56a7624",
              integer_attributes: [],
              string_attributes: [
                { attribute_name: "Name", attribute_value: "Swimming pool" },
              ],
              product_summary: {
                images: {
                  icon: this.unitLogo,
                  smallImage: this.unitLogo,
                  bigImage: this.unitLogo,
                  alternateImages: [
                    {
                      type: "unit",
                      fileUrl: this.unitLogo,
                      url: this.unitLogo,
                      fileName: this.fileName,
                      fileSize: this.fileSize,
                    },
                    {
                      type: "floor",
                      fileUrl: this.unitLogo,
                      url: this.unitLogo,
                      fileName: this.fileName,
                      fileSize: this.fileSize,
                    },
                  ],
                },
              },
              tags: ["Swimming pool"],
              createdAt: "2024-10-03T14:46:56.302Z",
              updatedAt: "2024-10-03T14:46:56.302Z",
              avgRating: 0,
              totalReviews: 0,
              itemIndex: 5942,
              _id: "66feae600f29f90b1bea79ae",
            },
          ],
          propertyType: {
            id: this.prop.id,
            name: this.prop.name,
          },
          creditReport: false,
          cxScore: false,
          propertyCategory: "STANDALONE",
        };
        if (this.unitType.label === "studio") {
          payload.Bedrooms = 0;
          payload.Bathrooms = 1;
        } else if (this.unitType.label === "1 Bed 1 Bath") {
          payload.Bedrooms = 1;
          payload.Bathrooms = 1;
        } else if (this.unitType.label === "2 Bed 2 Bath") {
          payload.Bedrooms = 2;
          payload.Bathrooms = 2;
        } else if (this.unitType.label === "3 Bed 2.5 Bath") {
          payload.Bedrooms = 3;
          payload.Bathrooms = 2.5;
        }

        await this.$store.dispatch("unit/createUnit", payload).then((res) => {
          this.$swal({
            title: "Success",
            text: "Unit Added successfully!!",
            type: "success",
          });
          this.unit = "";
          this.unitLogo = null;
          this.fileName = "";
          this.fileSize = "";
          this.unitList();
        });
      } catch (e) {
        this.$toasted.error(e.message);
      } finally {
        this.isCreating = false;
      }
    },
    async unitList() {
      await this.$store
        .dispatch("unit/totalUnitList", "66fa140f6a471d55dac5177b")
        .then((res) => {
          this.units = res;
        });
    },
  },
  mounted() {
    this.propertyList();
    this.unitList();
  },
};
</script>

<style>
.cardBg {
  height: auto; /* Changed to auto for responsive height */
  padding: 10px;
}
.upload_file-Custome {
  display: flex;
}

.upload_file-Custome p {
  display: inline-block;
  line-height: 3;
  cursor: pointer;
}

.file-upload-sec {
  height: 50px;
  width: 50px;
  border-radius: 100px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 4px solid #ffffff;
  overflow: hidden;
  background-image: linear-gradient(to bottom, #415eb6 50%, #ffffff 50%);
  background-size: 100% 200%;
  transition: all 1s;
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
}

.custom-file {
  position: absolute;
  width: 250px;
  top: 13px;
  height: 47px;
  opacity: 0;
  cursor: pointer;
}

.custom-file-input {
  height: 47px !important;
  cursor: pointer !important;
}

.attachIcon {
  border-radius: 30px;
  height: 45px;
  width: 45px;
  background-color: #2d6c44;
  color: #fff;
}
@media (max-width: 767px) {
  .currencyNameDropdown {
    width: 100%; /* Ensures dropdowns take full width on mobile */
  }
  .w-100 {
    width: 100% !important;
  }
  .upload_file-Custome {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media (min-width: 768px) {
  .cardBg {
    height: 500px;
  }
}
/* Custom Loader Styling */
.loader {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 54px;
  height: 54px;
  border-radius: 10px;
  z-index: 9999;
}

.loader div {
  width: 8%;
  height: 24%;
  background: rgb(128, 128, 128);
  position: absolute;
  left: 50%;
  top: 30%;
  opacity: 0;
  border-radius: 50px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  animation: fade458 1s linear infinite;
}

@keyframes fade458 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0.25;
  }
}

.loader .bar1 {
  transform: rotate(0deg) translate(0, -130%);
  animation-delay: 0s;
}

.loader .bar2 {
  transform: rotate(30deg) translate(0, -130%);
  animation-delay: -1.1s;
}

.loader .bar3 {
  transform: rotate(60deg) translate(0, -130%);
  animation-delay: -1s;
}

.loader .bar4 {
  transform: rotate(90deg) translate(0, -130%);
  animation-delay: -0.9s;
}

.loader .bar5 {
  transform: rotate(120deg) translate(0, -130%);
  animation-delay: -0.8s;
}

.loader .bar6 {
  transform: rotate(150deg) translate(0, -130%);
  animation-delay: -0.7s;
}

.loader .bar7 {
  transform: rotate(180deg) translate(0, -130%);
  animation-delay: -0.6s;
}

.loader .bar8 {
  transform: rotate(210deg) translate(0, -130%);
  animation-delay: -0.5s;
}

.loader .bar9 {
  transform: rotate(240deg) translate(0, -130%);
  animation-delay: -0.4s;
}

.loader .bar10 {
  transform: rotate(270deg) translate(0, -130%);
  animation-delay: -0.3s;
}

.loader .bar11 {
  transform: rotate(300deg) translate(0, -130%);
  animation-delay: -0.2s;
}

  .loader .bar12 {
    transform: rotate(330deg) translate(0, -130%);
    animation-delay: -0.1s;
  }
  .btn-height-40 {
    height: 40px;
  }
  .upload_file-Custome {
  flex-wrap: nowrap;
}

.file-hint {
  white-space: nowrap;
  font-size: 13px;
  color: #6c757d;
}

</style>
